import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const LIBRARY = buildModuleApi({
    prefix: "LIBRARY",
    uri: "library",
    withExtra: false,
    exclude: ["LIST", "CREATE", "UPDATE", "REMOVE", "DETAIL", "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    extraActions: {
        GROUP_LIST: { suffix: "/groups" }, GROUP_CREATE: { suffix: "/groups" }, GROUP_UPDATE: { suffix: "/groups" }, GROUP_REMOVE: { suffix: "/groups" },
        GROUP_ARCHIVE_LIST: { suffix: "/groups/archived/list" }, GROUP_ARCHIVE: { suffix: "/groups/:id/archive" }, GROUP_RESTORE: { suffix: "/groups/:id/restore" },
        PDF_LIST: { suffix: "/documents" }, PDF_UPLOAD: { suffix: "/documents/upload" }, PDF_UPDATE: { suffix: "/documents" }, PDF_REMOVE: { suffix: "/documents" }, PDF_FILE: { suffix: "/documents/:id/file" },
        PDF_ARCHIVE_LIST: { suffix: "/documents/archived/list" }, PDF_ARCHIVE: { suffix: "/documents/:id/archive" }, PDF_RESTORE: { suffix: "/documents/:id/restore" },
    },
});

export const LIBRARY_API = LIBRARY.API;
export const LIBRARY_CONSTANTS = LIBRARY.CONSTANTS;
export const LIBRARY_ENDPOINTS = LIBRARY.ENDPOINTS;
